import HttpClienteSeguroCore from "../../Servicios/HttpClienteSeguroCore";
import httpClientePublicoCore from "../../Servicios/httpClientePublicoCore";
import axios from "axios";

export const obtenerCompania = (ComCompanyId) => {
  return new Promise((resolve, reject) => {
    HttpClienteSeguroCore.get("/Compania/" + ComCompanyId)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        resolve(error.response);
      });
  });
};

export const obtenerConfiguracionAppCompania = (
  ComCompanyId,
  PortalCode = "ING",
) => {
  return new Promise((resolve, reject) => {
    HttpClienteSeguroCore.get(
      "/Compania/Config/" + ComCompanyId + "/" + PortalCode,
    )
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        resolve(error.response);
      });
  });
};

export const obtenerListadoCompaniaPortales = (registro) => {
  return new Promise((resolve, reject) => {
    httpClientePublicoCore
      .post("/Compania/CompaniasPortales/", registro)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        resolve(error.response);
      });
  });
};

export const obtenerConfiguracionHoraFecha = (CompanyId) => {
  return new Promise((resolve, reject) => {
    HttpClienteSeguroCore.get("/Compania/ConfigHoraFecha/" + CompanyId)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        resolve(error.response);
      });
  });
};

export const obtenerMonedaBase = (registro) => {
  return new Promise((resolve, reject) => {
    HttpClienteSeguroCore.post("/Compania/ObtieneMonedaBase/", registro)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        resolve(error.response);
      });
  });
};

/**
 * obtener imagen.
 * @param {{
 * companyId:string,
 * peticionUsuario:{ companyId:string, userId:string, optionId:string, action:string }}} objectRequest
 * @returns {Promise<{data:{documentName:string, extension:string, contentBase64:string, referenceObjectId:string, objectId:string}, status:number }>}
 */
export const obtenerImagenReducida = (objectRequest) => {
  return new Promise((resolve, reject) => {
    HttpClienteSeguroCore.post("/Compania/ObtenerImagenReducida", objectRequest)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        resolve(error.response);
      });
  });
};

export const obtenerCompaniaDefecto = (objectRequest) => {
  return new Promise((resolve, reject) => {
    httpClientePublicoCore
      .post("/Compania/CompaniaDefecto", objectRequest)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        resolve(error.response);
      });
  });
};

/**
 * Valida un email usando la API de Zerobounce
 * @param {string} email - Email a validar
 * @param {string} zerobounceUrl - URL base de la API de Zerobounce
 * @param {string} zerobounceApiKey - API Key de Zerobounce
 * @returns {Promise<{success: boolean, status: string, error?: string}>}
 */
export const validarEmailZerobounce = (
  email,
  zerobounceUrl,
  zerobounceApiKey,
) => {
  return new Promise((resolve, reject) => {
    const url = `${zerobounceUrl}?email=${email}&api_key=${zerobounceApiKey}`;

    axios
      .get(url)
      .then((response) => {
        if (response.data && response.data.status) {
          resolve({
            success: true,
            status: response.data.status,
            data: response.data,
          });
        } else {
          resolve({
            success: false,
            error: "Invalid response format",
          });
        }
      })
      .catch((error) => {
        resolve({
          success: false,
          error: error.message || "Error validating email with Zerobounce",
        });
      });
  });
};

/**
 * Envía código de verificación de 6 dígitos al email especificado
 * @param {string} companyId - ID de la compañía
 * @param {string} emailAddress - Email donde se enviará el código
 * @param {string} customerId - ID del cliente (opcional)
 * @param {string} languageCode - Código de idioma (ES, EN, PT)
 * @returns {Promise<{success: boolean, error?: string}>}
 */
export const enviarCodigoVerificacion = (
  companyId,
  emailAddress,
  customerId = null,
  languageCode = "ES",
) => {
  return new Promise((resolve, reject) => {
    HttpClienteSeguroCore.post("/CIFInfo/ValidaCorreo", {
      companyId,
      emailAddress,
      customerId,
      languageCode,
    })
      .then((response) => {
        resolve({
          success: true,
          data: response.data,
        });
      })
      .catch((error) => {
        resolve({
          success: false,
          error:
            error.response?.data?.mensaje ||
            error.message ||
            "Error al enviar código de verificación",
        });
      });
  });
};

/**
 * Valida el código de verificación de 6 dígitos ingresado por el usuario
 * @param {string} email - Email a verificar
 * @param {string} code - Código de 6 dígitos
 * @param {string} companyId - ID de la compañía
 * @returns {Promise<{success: boolean, isValid: boolean, message: string, verificationId?: string, error?: string}>}
 */
export const validarCodigoVerificacion = ({
  email,
  code,
  companyId,
  userId,
}) => {
  return new Promise((resolve, reject) => {
    HttpClienteSeguroCore.post("/CIFInfo/VerificarCodigoCorreo", {
      email,
      code,
      companyId,
      userId,
    })
      .then((response) => {
        resolve({
          success: true,
          isValid: response.data.isValid,
          message: response.data.message,
          verificationId: response.data.verificationId,
        });
      })
      .catch((error) => {
        resolve({
          success: false,
          isValid: false,
          error:
            error.response?.data?.mensaje ||
            error.message ||
            "Error al validar código",
        });
      });
  });
};

/**
 * Cancela el código de verificación de 6 dígitos ingresado por el usuario
 * @param {string} email - Email a verificar
 * @param {string} code - Código de 6 dígitos
 * @param {string} companyId - ID de la compañía
 * @returns {Promise<{success: boolean, isValid: boolean, message: string, verificationId?: string, error?: string}>}
 */
export const cancelarCodigoVerificacion = ({
  email,
  code,
  companyId,
  userId,
}) => {
  return new Promise((resolve, reject) => {
    HttpClienteSeguroCore.post("/CIFInfo/CancelarCodigoCorreo", {
      email,
      companyId,
      userId,
    })
      .then((response) => {
        resolve({
          success: Boolean(response?.data?.success),
        });
      })
      .catch((error) => {
        resolve({
          success: false,
          isValid: false,
          error: "CancelVerificationCodeError",
        });
      });
  });
};
